{
  "api": {
    "locationValidationTitle": "Não foi possível validar sua localização",
    "thresholdTitle": "Fora do horário para check-in",
    "warehouseUnavailableTitle": "Armazém indisponível",
    "warehouseUnavailableMessage": "Entre em contato com o pessoal da unidade para prosseguir com o check-in manual",
    "characterLimitTitle": "A entrada excede o limite de caracteres",
    "genericTitle": "O check-in falhou. Por favor, tente novamente.",
    "recaptchaTitle": "A verificação falhou",
    "recaptchaMessage": "Não foi possível verificar sua solicitação. Tente novamente ou entre em contato com o pessoal da unidade."
  }
}
